import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const Features = () => {
  const { ref: titleRef, inView: titleInView } = useScrollAnimation();
  const { ref: cardsRef, inView: cardsInView } = useScrollAnimation({ threshold: 0.2 });

  const features = [
    {
      iconSrc: '/icons/cycle-tracking.svg',
      title: 'Cycle Tracking',
      description: 'Precise logs for your health and physical rhythm with predictive insights.'
    },
    {
      iconSrc: '/icons/faith-aware.svg',
      title: 'Faith-Aware Guidance',
      description: 'Reminders for prayers, fasting and dhikr adjusted to your cycle phase.'
    },
    {
      iconSrc: '/icons/personalized.svg',
      title: 'Personalized Insights',
      description: 'Understanding how hormonal shifts affect your spiritual energy and focus.'
    },
    {
      iconSrc: '/icons/community.svg',
      title: 'Community',
      description: 'A safe space to connect with sisters sharing similar journey.'
    }
  ];

  return (
    <section id="features" className="features-section">
      <Container>
        <div 
          ref={titleRef}
          className={`features-header text-center animate-on-scroll fade-in-up ${titleInView ? 'visible' : ''}`}
        >
          <h2 className="features-main-title">
            Every Stage of Womanhood.<br />
            One Faithful Companion.
          </h2>
          <p className="features-subtitle">
            Every stage of womanhood. One faithful companion. Designed for Your Holistic 
            Wellness Every feature is crafted with the specific need of Muslim women in 
            mind respecting your privacy and your practice
          </p>
        </div>

        <Row 
          ref={cardsRef}
          className={`g-4 justify-content-center stagger-container ${cardsInView ? 'visible' : ''}`}
        >
          {features.map((feature, index) => (
            <Col xs={12} sm={6} lg={3} key={index}>
              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <div className="feature-icon">
                    <img 
                      src={feature.iconSrc} 
                      alt={feature.title}
                      className="feature-icon-img"
                    />
                  </div>
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Features;